import styled from 'styled-components';

const StyledSeperator = styled.div`
  margin: 6px 0;
  border-bottom: ${(props) => props.height} solid ${(props) => props.color};
`;

export default StyledSeperator;
